import {
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR,
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST,
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS,
} from "../actions";
import { SFunctionTemplatesSlice } from "./types";
import { FunctionTemplatesActions } from "../actionCreators";

import byTemplateIdReducer from "./byTemplateId";

const initialState: SFunctionTemplatesSlice = {
  byTemplateId: {},
};

const rootFunctionTemplatesReducer = (
  state = initialState,
  action: FunctionTemplatesActions
): SFunctionTemplatesSlice => {
  switch (action.type) {
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST:
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS:
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR:
      return {
        ...state,
        byTemplateId: byTemplateIdReducer(state.byTemplateId, action),
      };

    default:
      return state;
  }
};

export default rootFunctionTemplatesReducer;
